import PropTypes from 'prop-types';
import { ComponentLoader } from '../../../global/ComponentLoader/ComponentLoader';

const importFunc = () => {
    return import(
        /* webpackChunkName: "PdpSharedCallDealerModalWrapper" */
        './PdpSharedCallDealerModalWrapper'
    ).then(moduleExport => moduleExport.PdpSharedCallDealerModalWrapper);
};

export function PdpSharedCallDealerModalLoader(props) {
    return <ComponentLoader {...props} load={props.isOpen} importFunc={importFunc} />;
}

PdpSharedCallDealerModalLoader.propTypes = {
    isOpen: PropTypes.bool.isRequired,
};
